import Backbone from 'backbone';
import 'usabilla';
import { UsabillaInlineCampaigns } from 'views/store/common/usabilla/_usabilla_inline_campaigns';
import { USABILLA } from '../../../../../config/third_party';

export const FeedbackView = Backbone.View.extend({
	/**
	 * @returns {void}
	 */
	initialize: function() {
		this.initUsabilla();
		UsabillaInlineCampaigns.initInlineCampaigns();
	},
	/**
	 * @returns {void}
	 */
	initUsabilla: function() {
		const dlStoreName = window.dataLayer.storeName || 'none',
			dlSiteName = window.dataLayer.siteName || 'none',
			dlPageName = window.dataLayer.pageName || 'none',
			dlIsLoggedIn = Boolean(window.dataLayer.isLoggedIn),
			dlCartQuantity = window.dataLayer.cartQuantity || 0,
			dlCustomerHasProjects = Boolean(window.dataLayer.customerHasProjects),
			dlIsFirstTimeUser = Boolean(window.dataLayer.isFirstTimeUser),
			dlViewPath = window.dataLayer.viewPath || 'none',
			dlLastPageVisit = window.dataLayer.lastPageVisit || 'none',
			dlProType = (window.dataLayer.customer && window.dataLayer.customer.proType) || 'consumer',
			dlEmailSignup = window.dataLayer.emailSignup,
			dlBreadCrumbs = window.dataLayer.breadcrumbs || 'none',
			dlIsPro = window.dataLayer.customer && window.dataLayer.customer.isPro,
			dlPage = window.dataLayer.page || 'none',
			dlSearchTerm = window.dataLayer.searchTerm || 'none',
			dlApplication = (window.dataLayer.product && window.dataLayer.product.application) || 'none',
			dlType = (window.dataLayer.product && window.dataLayer.product.type) || 'none',
			dlManufacturer = window.dataLayer.manufacturer || 'none',
			dlBaseCategory = window.dataLayer.baseCategory || 'none',
			dlHasRoomChecklists =
				window.dataLayer.model &&
				window.dataLayer.model.shoppingListData &&
				window.dataLayer.model.shoppingListData.groups &&
				window.dataLayer.model.shoppingListData.groups.some((group) => group.checklist),
			dlCustomerId = (window.dataLayer.customer && window.dataLayer.customer.userDBID) || 0;
		window.usabilla_live = window.lightningjs.require('usabilla_live', `//w.usabilla.com/${USABILLA.MAIN_BUTTON_ID}.js`);
		window.usabilla_live('data', {
			custom: {
				storeName: dlStoreName,
				siteName: dlSiteName,
				pageName: dlPageName,
				isLoggedIn: dlIsLoggedIn,
				cartQuantity: dlCartQuantity,
				customerHasProjects: dlCustomerHasProjects,
				isFirstTimeUser: dlIsFirstTimeUser,
				viewPath: dlViewPath,
				lastPageVisit: dlLastPageVisit,
				proType: dlProType,
				emailSignup: dlEmailSignup,
				breadcrumbs: dlBreadCrumbs,
				pro: dlIsPro,
				page_type: dlPage,
				manufacturer: dlManufacturer,
				Application: dlApplication,
				type: dlType,
				search_term: dlSearchTerm,
				baseCategory: dlBaseCategory,
				hasRoomChecklists: dlHasRoomChecklists,
				customerId: dlCustomerId
			}
		});
		if (!window.BCOM.device.isDesktop) {
			window.usabilla_live('hide');
		}
	}
});
